module.exports = __webpack_public_path__ + "img/about-us-zs-3.4381f8c1.png";